"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGSSContext = exports.GSSContext = void 0;
const react_1 = require("react");
exports.GSSContext = (0, react_1.createContext)({
    gss: null,
    fgss: null,
    setGSS: () => Promise.resolve(),
    setFGSS: () => Promise.resolve(),
    resetGSS: () => Promise.resolve(),
});
function useGSSContext() {
    return (0, react_1.useContext)(exports.GSSContext);
}
exports.useGSSContext = useGSSContext;
//# sourceMappingURL=gss-context.js.map